import React from 'react';

import { TableCell, TableRow } from '@material-ui/core';

import { TStandingType } from '../../../../../../store/admin/eventAwards/store';
import { IAdminTeamResult } from '../../../../../../store/admin/teamResults/store';
import { ScoreType } from '../../../../../../store/admin/eventFormats/store';

import { DollarInputAdornment } from '../../../../../../components/DollarInputAdornment/DollarInputAdornment';
import { EditableTableCell } from '../../../../Common/EditableTableCell/EditableTableCell';
import {
  useAssignResultsDispatch,
  useAssignResultsState
} from '../../AssignResults/Context/AssignResults.context';
import { blankAward } from '../../Utils/blankAward';
import { getUserAwards } from '../Utils/getUserAwards';
import { getUserAwardField } from '../Utils/getUserAwardField';
import { displayPosition } from '../../../../../../contrib/Utils/displayPosition';
import { capitalizeFirstLetter } from '../../../../../../contrib/utils';

interface IProps {
  result: IAdminTeamResult;
}

export const TeamResultsTableRow = (props: IProps) => {
  const { result } = props;
  const {
    awardsToUpdate,
    editMode,
    selectedCombination,
    userAwards,
    selectedTeamFormat
  } = useAssignResultsState();

  const { dispatch } = useAssignResultsDispatch();

  if (!selectedCombination) {
    return <></>;
  }

  const onAwardChange = (userId: number, field: TStandingType) => (event: any) => {
    const allUserAwards = getUserAwards(userId, userAwards, awardsToUpdate);

    const userAward = (allUserAwards || []).find(award => award.user === userId);

    userAward && userAward.id > 0
      ? dispatch({
          type: 'setAwardToUpdate',
          value: {
            award: { ...userAward, [field]: event.target.value, team: userId, user: userId },
            userId
          }
        })
      : dispatch({
          type: 'setAwardToUpdate',
          value: {
            award: {
              ...blankAward,
              ...userAward,
              team: userId,
              user: userId,
              [field]: event.target.value
            },
            userId
          }
        });
  };

  const { scoreType: selectedScoreType } = selectedCombination;

  const scoreType = capitalizeFirstLetter(ScoreType[selectedScoreType].toLowerCase());
  const teamFormatScoreType = `${selectedTeamFormat}${scoreType}`;
  const auxScoreFieldField = `${teamFormatScoreType}AuxScore`;

  return selectedCombination ? (
    <TableRow className="results-table-table-body-row">
      <TableCell>
        {displayPosition(result, selectedTeamFormat, selectedCombination.scoreType)}
      </TableCell>
      <TableCell>{`${result.teamName}`}</TableCell>

      <TableCell colSpan={selectedCombination.format.format.prefix !== 'stroke' ? 2 : 1}>
        {result[auxScoreFieldField as keyof IAdminTeamResult]}
      </TableCell>
      <EditableTableCell
        label="label"
        type="number"
        value={getUserAwardField(result.teamId, 'points', userAwards, awardsToUpdate)}
        editMode={editMode}
        onChange={onAwardChange(result.teamId, 'points')}
        noIcon={true}
      />

      <EditableTableCell
        label="label"
        type="number"
        value={getUserAwardField(result.teamId, 'scrip', userAwards, awardsToUpdate)}
        editMode={editMode}
        onChange={onAwardChange(result.teamId, 'scrip')}
        inputAdornment={<DollarInputAdornment />}
        valuePrefix="$ "
        noIcon={true}
      />
      <EditableTableCell
        label="label"
        type="number"
        value={getUserAwardField(result.teamId, 'cash', userAwards, awardsToUpdate)}
        editMode={editMode}
        onChange={onAwardChange(result.teamId, 'cash')}
        inputAdornment={<DollarInputAdornment />}
        valuePrefix="$ "
        noIcon={true}
      />
    </TableRow>
  ) : (
    <></>
  );
};
